import React from "react";

interface PaginatorElementProps {
    className: string;
    display: boolean;
    text: string;
    onClick?: Function;
}

interface PaginatorProps {
    pageNumber: number;
    totalPages: number;
    onPageChange: Function;
}

const PaginatorElement = (props: PaginatorElementProps) => {
    if (props.display) {
        return (
            <div
                className={props.className}
                onClick={() => {
                    if (props.onClick) {
                        props.onClick();
                    }
                }}
            >
                {props.text}
            </div>
        );
    }
    return <div />;
};

const Paginator = (props: PaginatorProps) => {
    if (props.onPageChange) {
        return (
            <div className={"paging"}>
                <PaginatorElement
                    text={"⮜"}
                    className={"arrow prev"}
                    display={props.pageNumber > 1}
                    onClick={() => props.onPageChange(props.pageNumber - 1)}
                />
                <PaginatorElement
                    text={`page ${props.pageNumber} of ${props.totalPages}`}
                    className={"pagenum"}
                    display={props.totalPages > 0}
                />
                <PaginatorElement
                    text={"⮞"}
                    className={"arrow next"}
                    display={props.pageNumber < props.totalPages}
                    onClick={() => props.onPageChange(props.pageNumber + 1)}
                />
            </div>
        );
    }
    return null;
};

export default Paginator;
